var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import { Tag } from '../../../../Tag';
import { ComboboxTestIdFactory } from '../../interactions';
import styles from './ComboboxTagList.module.css';
export const ComboboxTagList = ({ currentSelectedOptionIndex, 'data-testid': testId, disabled, onTagClick, select, selectedOptions, tagListClassName, }) => {
    return (_jsx("ol", { "aria-label": "selected items", className: C(styles.Container, styles.TagList, tagListClassName), "data-testid": ComboboxTestIdFactory.getComboboxTagListOl(testId), role: "listbox", ...(disabled ? { 'aria-disabled': true } : {}), children: selectedOptions.map((option, index) => {
            return (_jsx("li", { className: styles.TagListItem, role: "none", children: _jsx(Tag, { "data-testid": ComboboxTestIdFactory.internalGenerateTagLiTestId(testId, option.testIdSegment ?? option.id), disabled: disabled, isFocused: currentSelectedOptionIndex === index, onClear: (e) => {
                        e.stopPropagation();
                        onTagClick(-1);
                        select(option);
                    }, onClick: () => {
                        onTagClick(index);
                    }, tabIndex: -1, value: option.text }) }, option.id));
        }) }));
};
_react_refresh_temp_1 = ComboboxTagList;
$RefreshReg$(_react_refresh_temp_1, "ComboboxTagList");
